export default __webpack_public_path__ + "static/media/snowuns-merch.b039ae52.webp";